import { render, staticRenderFns } from "./EditDisease.vue?vue&type=template&id=02c5b8fa"
import script from "./EditDisease.vue?vue&type=script&lang=js"
export * from "./EditDisease.vue?vue&type=script&lang=js"
import style0 from "./EditDisease.vue?vue&type=style&index=0&id=02c5b8fa&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports